export const addPetClicked = () => ({
  type: 'Add Pet Clicked',
});
